import {
  searchEventsRoutePaths,
  searchInternshipsRoutePaths,
  searchJobsRoutePaths,
  searchOrgsRoutePaths,
  searchVolopsRoutePaths,
} from '#/modules/search/routing/search.route-paths';
import type { SearchType } from '#/modules/search/types/SearchType';

export function getListingTypeFromPathname(pathname: string): SearchType {
  if (searchJobsRoutePaths.includes(pathname)) {
    return 'JOB';
  }

  if (searchInternshipsRoutePaths.includes(pathname)) {
    return 'INTERNSHIP';
  }

  if (searchVolopsRoutePaths.includes(pathname)) {
    return 'VOLOP';
  }

  if (searchEventsRoutePaths.includes(pathname)) {
    return 'EVENT';
  }

  if (searchOrgsRoutePaths.includes(pathname)) {
    return 'ORG';
  }

  return 'JOB';
}
